import { ListItem, styled } from "@mui/material";
import { exProps } from "utils/mui";

export const MyListItem = styled(ListItem, exProps("disabled"))<{ disabled: boolean }>(({ theme, disabled }) => ({
  paddingLeft: 0, 
  paddingRight: 0, 
  borderBottom: `1px solid ${theme.palette.divider}`,
  color: disabled? theme.palette.text.secondary: theme.palette.text.primary
}))